"use strict";

exports.__esModule = true;
exports.MiscClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const MiscClient = {
  fetch(data, id) {
    const requestId = `MISC_FETCH_${id}`;
    const endPoint = _constants.ENDPOINTS.MISC_FETCH;
    return _http.$http.post(requestId, endPoint, {
      data
    }).then(({
      data
    }) => data);
  }
};
exports.MiscClient = MiscClient;